import { React, useCallback, useEffect, useState } from "react"
import { useAuth0 } from "@auth0/auth0-react"

export const useJobApplications = () => {
  const [applications, setApplications] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const { getAccessTokenSilently } = useAuth0()
  const apiUrl = process.env.REACT_APP_API_URL

  const fetchApplications = useCallback(async () => {
    try {
      setLoading(true)
      setError(null)
      const token = await getAccessTokenSilently({
        authorizationParams: {
          audience: process.env.REACT_APP_API_AUDIENCE,
        },
      })
      const response = await fetch(`${apiUrl}/api/JobApplications/user`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      if (response.ok) {
        const data = await response.json()
        setApplications(data)
      } else {
        throw new Error("Failed to fetch job applications")
      }
    } catch (error) {
      setError(error.message)
    } finally {
      setLoading(false)
    }
  }, [apiUrl, getAccessTokenSilently])

  useEffect(() => {
    fetchApplications()
  }, [fetchApplications])

  return { applications, loading, error, refreshApplications: fetchApplications }
}

